import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { filter, map, pluck } from 'rxjs/operators';
import { UserLoginModel } from '../../../shared/models/business-transaction/user-login.model';
import { BusinessTransactionService } from '../../../shared/services/business-transaction/business-transaction.service';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { SystemNotificationService } from '../../../shared/services/realtime-messaging/system-notification.service';
import { WipSearchService } from '../../services/wip-search.service';
import { AssignmentBase } from '../assignment-base.component';
import { ViewTransactionData, ViewTransactionWindow } from './view-transaction-modal.component';

export class OpenTransactionData {
    constructor(public businessTransactionNumberId: string, public status: number, public originator: UserLoginModel,
        public recipient: UserLoginModel, public recipientUserId: number, public agentNumber: number, public openToEditMode: boolean = false) {}
}

@Component({
    selector: 'open-transaction-modal',
    templateUrl: './open-transaction-modal.html'
})
export class OpenTransactionWindow extends AssignmentBase {
    WIP_STATUS_ACTIVE = 1;
    assignmentBusinessTransactions: any = new Array();
    loaded = false;
    private readonly selectedTransactionNumberId = this.data.businessTransactionNumberId !== undefined ? +this.data.businessTransactionNumberId : undefined;

    constructor(
        public dialogRef: MatDialogRef<OpenTransactionWindow>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: OpenTransactionData,
        public modalService: MvdModalService,
        public systemNotificationService: SystemNotificationService,
        public businessTransactionService: BusinessTransactionService,
        private wipSearchService: WipSearchService
    ) {
        super(modalService, systemNotificationService, businessTransactionService);
    }

    ngOnInit() {
        let assignedUserLoginId: number;

        if (this.data.originator == null) {
            assignedUserLoginId = 0;
        } else {
            assignedUserLoginId = this.data.originator.id;
        }

        this.wipSearchService.getServicesGroupAssignedToUser(this.data.agentNumber, assignedUserLoginId)
            .pipe(
                pluck('results'),
                filter(results => !!results),
                map(results => results.filter(p => p.businessTransactionNumberId !== this.selectedTransactionNumberId)
                    .map(p => p.businessTransactionNumberId))
            )
            .subscribe(
                assignments => {
                    this.assignmentBusinessTransactions = assignments.slice(0);
                    this.loaded = true;
                },
                err => this.handleValidationResult(err));
    }

    public accept(result) {
        this.dialogRef.close(result);
    }

    public cancel() {
        this.dialogRef.close();
    }

    async redirectToTransaction() {
        try{
            await this.assignUnassignedTransactions();
            await this.startSelectedTransaction();
            this.accept(this.data);
        } catch (err) {
            this.handleValidationResult(err);
        }
    }

    viewTransaction() {
        const data = new ViewTransactionData(this.selectedTransactionNumberId);
        this.modalService.open(ViewTransactionWindow, data);
    }

    private async assignUnassignedTransactions() {
        const hasTransactionsWithoutOriginator = this.data.originator == null && this.assignmentBusinessTransactions.length > 0;
        if (hasTransactionsWithoutOriginator) {
            await this.performAssignment(this.assignmentBusinessTransactions, this.data.status, this.data.recipient, this.data.originator, this.data.recipientUserId)
                .toPromise();
        }
    }

    private async startSelectedTransaction() {
        await this.performAssignment(this.data.businessTransactionNumberId, this.data.status, this.data.recipient, this.data.originator, this.data.recipientUserId, true)
            .toPromise();
    }
}
